module.exports = __webpack_public_path__ + "img/copa_oro.0590fdf2.png";